import { Observable, of as observableOf } from 'rxjs';
import { AbstractApiModel } from './abstract-api-model';

export class RobotModel extends AbstractApiModel<RobotModel> {
  name: string;
  productId: string;
  features: string[] = [];
  usbDevices: string[] = [];
  batteryThresholds: number[] = [];
  solutions: string[];
  productRevision: string;
  explorerFileID: number;

  deserialize(json: any): this {
    this.name = json.name;
    this.solutions = json.solutions;
    this.features = json.features;
    this.usbDevices = json.usb_devices;
    this.batteryThresholds = json.battery_thresholds;
    this.productId = json.product_id;
    this.productRevision = json.product_revision;
    this.explorerFileID = json.explorer_model_id;

    return super.deserialize(json);
  }

  serialize(): any {
    return Object.assign(super.serialize(), {
      name: this.name,
      product_id: this.productId,
      product_revision: this.productRevision,
      battery_thresholds: this.batteryThresholds,
      solutions: this.solutions,
      features: this.features,
      usb_devices: this.usbDevices,
      explorer_model_id: this.explorerFileID
    });
  }

  static getCameraFields(robotModel: RobotModel): Observable<any[]> {
    if (robotModel && robotModel.productId?.toLowerCase()?.includes('otter')) {
      return observableOf([
        {
          'name': 'NearField',
          'type': 'inspect',
          'minViewExtent': 0.635,
          'maxViewExtent': 8.838,
          'minViewWidth': 2.82,
          'maxViewWidth': 14.15
        },
        {
          'name': 'FarField',
          'type': 'inspect',
          'minViewExtent': 2.959,
          'maxViewExtent': 17.852,
          'minViewWidth': 1.56,
          'maxViewWidth': 8.59
        },
        {
          'name': 'ProximityFront',
          'type': 'proximity',
          'minViewExtent': -0.135,
          'maxViewExtent': 1.740,
          'minViewWidth': 2.157,
          'maxViewWidth': 2.815
        },
        {
          'name': 'ProximityRear',
          'type': 'proximity',
          'minViewExtent': 0.165,
          'maxViewExtent': -1.688,
          'minViewWidth': 2.164,
          'maxViewWidth': 2.773
        }
      ]);
    }
    else {
      return observableOf([
        {
          'name': 'NearField',
          'type': 'inspect',
          'minViewExtent': 0.387,
          'maxViewExtent': 4.599,
          'minViewWidth': 0.482,
          'maxViewWidth': 6.696
        },
        {
          'name': 'MidField',
          'type': 'inspect',
          'minViewExtent': 1.687,
          'maxViewExtent': 11.606,
          'minViewWidth': 1.486,
          'maxViewWidth': 8.315
        },
        {
          'name': 'FarField',
          'type': 'inspect',
          'minViewExtent': 3.699,
          'maxViewExtent': 20.272,
          'minViewWidth': 1.941,
          'maxViewWidth': 9.664
        },
        {
          'name': 'ProximityFront',
          'type': 'proximity',
          'minViewExtent': -0.135,
          'maxViewExtent': 1.740,
          'minViewWidth': 2.157,
          'maxViewWidth': 2.815
        },
        {
          'name': 'ProximityRear',
          'type': 'proximity',
          'minViewExtent': 0.165,
          'maxViewExtent': -1.688,
          'minViewWidth': 2.164,
          'maxViewWidth': 2.773
        }
      ]);
    }
  }
}
